<template>
    <!-- 导出报表 -->
    <div class="export">
      <div class="dataTime">
          <van-row>
              <van-cell title="查询开始时间：" is-link :value="dataForm.beginTime" @click="clickBegin(dataForm.beginTime)"/>
              <van-calendar ref="exportStartTime" v-model="showBegin" :value="dataForm.beginTime" :min-date="minDate" :max-date="maxDate" @confirm="onConfirmBegin" />
          </van-row>
          <van-row>
              <van-cell title="查询结束时间：" is-link :value="dataForm.endTime"  @click="clickEnd(dataForm.endTime)"/>
              <van-calendar ref="exportEndTime" v-model="showEnd" :min-date="minDate" :value="dataForm.endTime" :max-date="maxDate" @confirm="onConfirmEnd" />
          </van-row>
          <van-row style="margin:0 12px;">
          <van-button round block plain hairline type="info"  @click="getData">查 询</van-button>
          <van-button style="margin-top: 2%;" :disabled="isDisabled" round block  hairline type="info"  @click="exportData">导 出 报 表</van-button>
  
          </van-row>
      </div>
      <!-- <div ref="barChart" style="width: 97%;
        height: 400px;"></div> -->
    </div>
  </template>
  
  <script>
  import {formatDateTime,formatBeginTime,formatEndTime,getNowTime} from '../../utils/date'
  import {QueryExpiryBoxInfo} from '@/my_js/HttpRequest.js'
   import { Notify,Dialog } from 'vant'
  import * as XLSX from 'xlsx'
  export default {
  data(){
      return{
          myChart:null,
          showBegin:false,
          showEnd:false,
          dataForm:{
            beginTime:null,
            endTime:null
          },
          isDisabled:false,//导出按钮禁用
          responseDataArray:[],//响应数据数组
          minDate:new Date(2020,0,1),
          maxDate:new Date(2050,12,31)
      }
  },
  mounted(){
      const end = new Date()
      const start = new Date()
      end.setTime(start.getTime() - 3600 * 1000 * 24 * 7)//默认查询7天前数据
      const data = formatDateTime(end)
      console.log(data);
      this.dataForm.beginTime = data
      this.dataForm.endTime = data// 查询时间为1天
      this.getData()
    },
  methods:{
    
      // 获取数据
      getData(){
          const beginTime = formatBeginTime(this.dataForm.beginTime)
          const endTime = formatEndTime(this.dataForm.endTime)
          const dataArray = {
            startTime:beginTime,
            endTime:endTime
          }
          console.log('dataArray:',dataArray);
          QueryExpiryBoxInfo(dataArray).then(res =>{
            console.log('导出数据：',res);
            this.responseDataArray = res.data
            console.log('this.responseDataArray',this.responseDataArray);
            if(this.responseDataArray.length == 0){
                this.isDisabled = true
            }else if(this.responseDataArray.length != 0){
                this.isDisabled = false
            }
          })
          
      },
      // 选择日期并格式化时间
      onConfirmBegin(date){
        this.showBegin = false
        // 格式化时间
        this.dataForm.beginTime = formatDateTime(date)
        console.log('开始时间：',this.dataForm.beginTime);
        console.log(typeof(this.dataForm.beginTime));
      },
      //   开始时间定位到 beginTime
      clickBegin(date){
        this.showBegin = true
          this.$nextTick(() => {
              this.$refs.exportStartTime.reset(new Date(date))// 确保日历定位到指定时间
          })
      },
      //   结束时间定位到 endTime
      clickEnd(date){
        this.showEnd = true
          this.$nextTick(() => {
              this.$refs.exportEndTime.reset(new Date(date))// 确保日历定位到指定时间
          })
      },
      // 选择日期并格式化时间
      onConfirmEnd(date){
        this.showEnd = false
        // 格式化时间
        this.dataForm.endTime = formatDateTime(date)
        console.log('结束时间：',this.dataForm.endTime);
      },
    //   导出数据
    exportData(){
        Dialog.confirm({
            title: '提示',
            message: '是否确定导出数据？',
          })
          .then(() => {
            // on confirm
            console.log('点击了确定');
            this.exportAllData()
          })
          .catch(() => {
            // on cancel
            console.log('点击了取消');
          });
    },
    // 全部导出
    exportAllData () {
    import('@/utils/ExportExcel').then(excel => {
            const title = ['过期料盒信息及联系信息表('+ this.dataForm.beginTime + '  --  ' + this.dataForm.endTime+')']
            const tHeader = ['料盒编号', '车牌号', '联系方式1', '联系方式2', '存入时间']
            const filterVal = ['boxCode', 'plateNo', 'phoneNo1', 'phoneNo2', 'saveTime']
            const list = this.responseDataArray
            const data = this.formatJson(filterVal, list)
            const merges = [
            'A1:E1' //标题合并
            ]
            // const filename = '过期料盒信息及联系信息表'
            const filename = '过期料盒信息及联系信息表_'+ getNowTime()//当天时间
            // debugger
            console.log('data',data);
            
            excel.export_json_to_excel({
                header: tHeader,
                merges,
                data,
                filename,
                title
            })
        })
    },
    // 
    formatJson (filterVal, jsonData) {
        console.log('jsonData',jsonData);
        
      return jsonData && jsonData.map(v => filterVal.map(j => {
        return v[j]
      }))
    },
    
  }
  }
  </script>
  
  <style lang="scss">
  .van-dialog__confirm {
    background-color: #0094ff; /* 确认按钮背景色 */
    color: #fff; /* 确认按钮字体颜色 */
  }
  </style>